<h2 mat-dialog-title class="dialog-header">{{'finance.payment.assing.title'|traduccion}}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="dialog-content">
  <mat-button-toggle-group [(ngModel)]="mode" (change)="onChangeMode()" aria-label="Modo de asignacion">
    <mat-button-toggle value="assign">{{'finance.payment.assing.title'|traduccion}}</mat-button-toggle>
    <mat-button-toggle value="unassign">{{'finance.payment.unassing.title'|traduccion}}</mat-button-toggle>
  </mat-button-toggle-group>

  <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1">
    <mat-card class="assign-card">
      <mat-card-content>
        <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1">
          <mat-hint *ngIf="mode === 'assign'">{{'finance.payment.assing.info'|traduccion}}</mat-hint>
          <mat-hint *ngIf="mode === 'unassign'">{{'finance.payment.unassing.info'|traduccion}}</mat-hint>

          <div *ngIf="mode === 'assign'">
            <app-user-search-select
              [(selectedUser)]="selectedUser"
              [label]="'finance.payment.assing.selectedUser'"
              [noDataLabel]="'finance.payment.assing.selectedUser.nodata'">
            </app-user-search-select>
          </div>
        </div>

        <h6>{{'finance.payment.assing.table.title'|traduccion}}</h6>
        <app-data-table
          preset="modal"
          shellClass="table-card mat-elevation-z1"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [emptyMessage]="'No hay pagos seleccionados.'"
          [showPaginator]="true"
          [clientPagination]="true"
          [pageSize]="10"
          [pageSizeOptions]="[10, 25, 50]"
          [showFirstLastButtons]="true"
          [stickyHeader]="true">
          <ng-container matColumnDef="uuid">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.assing.table.header.uuid'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.uuid }}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.assing.table.header.createdAt'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.createdAt | date:'dd-MM-yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.assing.table.header.totalPrice'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.totalPrice|currency }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.assing.table.header.status'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">
              <app-data-table-badge
                [label]="r.status"
                [tone]="r.status === 'KO' ? 'danger' : (r.status === 'PENDING' ? 'warning' : 'success')">
              </app-data-table-badge>
            </td>
          </ng-container>
        </app-data-table>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button *ngIf="mode=='assign' && selectedRows.length > 0" mat-raised-button color="primary" [disabled]="!selectedUser || (assigning$ | async)" (click)="assingCustomerMassive()">
    <mat-icon>link</mat-icon>
    {{'finance.payment.assing.action.assing'|traduccion}}
  </button>
  <button *ngIf="mode=='unassign' && selectedRows.length > 0" mat-raised-button color="primary" [disabled]="assigning$ | async" (click)="unassingCustomerMassive()">
    <mat-icon>link</mat-icon>
    {{'finance.payment.assing.action.unassing'|traduccion}}
  </button>
</mat-dialog-actions>
